import { css } from '@emotion/css'
import { spacing, breakpoint, fontSize, mediaQueryHelper, shorthandHelper, colors } from '@offerzen/pinata'

const styles = {
  form: css({
    marginBottom: spacing.medium,
    paddingBottom: spacing.medium,
    borderBottom: `1px dashed ${colors.mystic}`,
  }),

  fieldSet: css({
    display: 'grid',
    gridTemplateColumns: '1fr',
    rowGap: spacing.default,

    [mediaQueryHelper(breakpoint.phone)]: {
      gridTemplateColumns: '1fr 1fr',
      columnGap: spacing.default,
    },
  }),

  fieldInput: css({
    width: '100%',

    '& input': {
      border: 0,
      height: '100% !important',
      backgroundColor: 'transparent',
      padding: shorthandHelper([spacing.small, 44, spacing.small, spacing.default]), // Override Rails styles
    },
  }),

  currentWorkField: css({
    margin: shorthandHelper([spacing.default, 0]),

    label: {
      marginBottom: 0, // Override Rails styles
    },
  }),

  buttons: css({
    marginTop: spacing.medium,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',

    '> * + *': {
      marginLeft: spacing.default,
    },
  }),

  cancel: css({
    fontSize: fontSize.default,
  }),

  description: css({
    textArea: {
      borderRadius: 0, // Override Rails style
    },
  }),
}

export default styles
